/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {css} from 'aphrodite';
import {Card} from 'react-bootstrap';
import Props, {BodyProps, HeadingProps, TitleProps} from './Props';
import styles from './styles';

const Panel = ({children}: Props): JSX.Element => {
	return <Card
		tabIndex={0}
		className={css(styles.card)}>{children}</Card>;
};

Panel.Heading = ({children}: HeadingProps): JSX.Element => {
	return <Card.Header>{children}</Card.Header>;
};

Panel.Title = ({children}: TitleProps): JSX.Element => {
	return <Card.Title as="h3" className={css(styles.title)}>{children}</Card.Title>;
};

Panel.Body = ({children}: BodyProps): JSX.Element => {
	return <Card.Body>{children}</Card.Body>;
};

export default Panel;
